import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import './LspNotesModal.scss';
const LspNotesModal = (props) => {
  const { t } = useTranslation();
  const { setForm_note, form_note } = props;
  let handleChange = (e) => {
    setForm_note(e.target.value);
  };
  useEffect(() => { }, []);

  return (
    <div
      className="modal notes-modal"
      id="lsp-notesModal"
      tabIndex={-1}
      aria-labelledby="notesModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="notesModalLabel">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.83333 5.08333H8M3.83333 8H10.5M3.83333 13V14.9463C3.83333 15.3903 3.83333 15.6123 3.92436 15.7263C4.00352 15.8255 4.12356 15.8832 4.25045 15.8831C4.39636 15.8829 4.56973 15.7442 4.91646 15.4668L6.90434 13.8765C7.31043 13.5517 7.51347 13.3892 7.73957 13.2737C7.94017 13.1712 8.15369 13.0963 8.37435 13.051C8.62306 13 8.88308 13 9.40312 13H11.5C12.9001 13 13.6002 13 14.135 12.7275C14.6054 12.4878 14.9878 12.1054 15.2275 11.635C15.5 11.1002 15.5 10.4001 15.5 9V4.5C15.5 3.09987 15.5 2.3998 15.2275 1.86502C14.9878 1.39462 14.6054 1.01217 14.135 0.772484C13.6002 0.5 12.9001 0.5 11.5 0.5H4.5C3.09987 0.5 2.3998 0.5 1.86502 0.772484C1.39462 1.01217 1.01217 1.39462 0.772484 1.86502C0.5 2.3998 0.5 3.09987 0.5 4.5V9.66667C0.5 10.4416 0.5 10.8291 0.585185 11.147C0.816353 12.0098 1.49022 12.6836 2.35295 12.9148C2.67087 13 3.05836 13 3.83333 13Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              {t("notes")}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <textarea
              onChange={(e) => handleChange(e)}
              className="notes-modal-text"
              placeholder="Type your note here."
              defaultValue={form_note ? form_note : ''}
            />
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
};

export default LspNotesModal;
